import BaseCard from 'components/Cards/BaseCard';
import {
  PersonnelList,
  PersonnelProvider,
  ResponderMapProvider,
  TourProvider,
} from 'features/Responder';
import { DutyList } from 'features/Responder/features/Duties';
import { PersonnelMap } from 'features/Responder/features/Personnel';
import { Group, Panel } from 'react-resizable-panels';
import { ResizablePanelHandle } from 'utils/panelResizeUtils';

export default function Personnel() {
  return (
    <PersonnelProvider>
      <TourProvider>
        <ResponderMapProvider>
          <Group
            orientation="horizontal"
            className="d-flex w-100 flex-grow-1 h-100"
            style={{ minHeight: 0, height: '100%' }}
          >
            <Panel defaultSize={50} minSize={30} className="d-flex flex-column h-100">
              <Group
                orientation="vertical"
                className="d-flex flex-column h-100"
                style={{ minHeight: 0 }}
              >
                <Panel defaultSize={50} minSize={30} className="d-flex flex-column h-100">
                  <BaseCard className="h-100 border-0 shadow-lg bg-dark text-white">
                    <div className="h-100 d-flex flex-column" style={{ minHeight: 0 }}>
                      <PersonnelList />
                    </div>
                  </BaseCard>
                </Panel>

                <ResizablePanelHandle direction="horizontal" />

                <Panel defaultSize={50} minSize={30} className="d-flex flex-column h-100">
                  <BaseCard className="h-100 border-0 shadow-lg bg-dark text-white">
                    <div className="h-100 d-flex flex-column" style={{ minHeight: 0 }}>
                      <PersonnelMap />
                    </div>
                  </BaseCard>
                </Panel>
              </Group>
            </Panel>

            <ResizablePanelHandle direction="vertical" />

            <Panel defaultSize={50} minSize={30} className="d-flex flex-column h-100">
              <BaseCard className="h-100 border-0 shadow-lg bg-dark text-white">
                <div className="h-100 d-flex flex-column" style={{ minHeight: 0 }}>
                  <DutyList />
                </div>
              </BaseCard>
            </Panel>
          </Group>
        </ResponderMapProvider>
      </TourProvider>
    </PersonnelProvider>
  );
}
